'use strict';

const parseMarkersCoordinates = function(data) {
  return data.reduce((acc, cur) => {
    const markerCoord = cur.polygons[0].polygon;

    const coords = markerCoord.split(';');
    const lat = Number(coords[0]);
    const lng = Number(coords[1]);

    return acc.concat({
      location: { lat: lat, lng: lng },
      content: cur,
    });
  }, []);
};

export default parseMarkersCoordinates;
